import { render } from "./CleIdentificationHome.vue?vue&type=template&id=97f545b4"
import script from "./CleIdentificationHome.vue?vue&type=script&lang=js"
export * from "./CleIdentificationHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__